export const platformManaged = 'EIAP';
export default {};
